import type { UAEvent } from 'api/googleTagManager'

type WishlistSaveAction = 'click' | 'save' | 'unsave'
type WishlistSaveElement = 'button' | 'modal' | 'modal_new_wishlist'

export function wishlistSaveEvent(
  element: WishlistSaveElement,
  action: WishlistSaveAction,
  offerType?: string,
): UAEvent {
  return {
    category: 'wishlists',
    action: `wishlist_${element}_${action}`,
    label: offerType,
  }
}

type WishlistPageAction = 'view' | 'create' | 'rename' | 'delete'

export function wishlistPageEvent(
  action: WishlistPageAction,
  wishlistId?: string,
): UAEvent {
  return {
    category: 'wishlists',
    action: `wishlist_page_${action}`,
    label: wishlistId,
  }
}
